import React from 'react'
import { Document, Page } from '@react-pdf/renderer'

import Attachments from './Attachments'
import Sections from 'src/parser/shared/PDF/Sections'
import Logs from './sections/Logs'
import UserTasks from './sections/UserTasks'
import Description from './sections/Description'
import Location from './sections/Location'
import Medias from './sections/Medias'
import { TAlarmReportProps } from 'src/parser/shared/PDF/Provider'
import AlarmTitle from 'src/parser/shared/PDF/Title/AlarmTitle'
import { AlarmHeader } from 'src/parser/shared/PDF/Header/CommonHeader'
import { PageFooter, styles } from 'src/parser/shared/PDF/PageFooter'
import Loadable from 'src/utils/Loadable'

const sections = [
  {
    title: 'alarm_report.description.title',
    Component: Description,
  },
  {
    title: 'alarm_report.location.title',
    Component: Location,
  },
  {
    title: 'alarm_report.medias.title',
    Component: Medias,
  },
  {
    title: 'alarm_report.logs.title',
    Component: Logs,
  },
  {
    title: 'alarm_report.user_tasks.title',
    Component: UserTasks,
  },
]

export const alarmPages = (props: TAlarmReportProps): JSX.Element[] => {
  const attachmentsData = Loadable.isSuccess(props.attachments)
    ? props.attachments.data
    : []

  const additionalDetailsData = Loadable.isSuccess(props.additionalDetails)
    ? props.additionalDetails.data
    : {}

  const hasExtraPage =
    attachmentsData.length > 0 ||
    (additionalDetailsData.videoUrls?.length ?? 0) > 0 ||
    (additionalDetailsData.imageUrls?.length ?? 0) > 0 ||
    (additionalDetailsData.audioUrls?.length ?? 0) > 0

  const id = props.entity.id

  const pages = [
    <Page
      key={`${id}-report`}
      style={styles.page}
      wrap
    >
      <AlarmTitle {...props} />
      <AlarmHeader {...props} />
      <Sections
        // @ts-expect-error
        sectionProps={props}
        sections={sections}
      />
      <PageFooter />
    </Page>,
  ]

  if (hasExtraPage) {
    pages.push(
      <Page
        key={`${id}-attachments`}
        style={styles.page}
        wrap
      >
        <AlarmTitle {...props} />
        <Attachments {...props} />
        <PageFooter />
      </Page>,
    )
  }

  return pages
}

export default (props: TAlarmReportProps): JSX.Element => (
  <Document>{alarmPages(props)}</Document>
)
